/**
 * バリデーション関数群
 * エラーメッセージを返す (正常時はnull)
 */

/**
 * カード番号のバリデーション
 * @param {string} cardNumber - カード番号
 * @returns {string|null} エラーメッセージまたはnull
 */
export const validateCardNumber = (cardNumber) => {
  const cleanCardNumber = cardNumber.replace(/\s/g, '');
  if (!cleanCardNumber) return 'カード番号を入力してください';
  if (cleanCardNumber.length < 13 || cleanCardNumber.length > 16) {
    return 'カード番号は13〜16桁で入力してください';
  }
  return null;
};

/**
 * 有効期限のバリデーション
 * @param {string} expiryMonth - 有効期限月
 * @param {string} expiryYear - 有効期限年
 * @returns {string|null} エラーメッセージまたはnull
 */
export const validateExpiry = (expiryMonth, expiryYear) => {
  if (!expiryMonth || !expiryYear) return '有効期限を入力してください';
  
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear() % 100;
  const currentMonth = currentDate.getMonth() + 1;
  
  const month = parseInt(expiryMonth);
  const year = parseInt(expiryYear);
  
  if (month < 1 || month > 12) return '正しい月を入力してください(01-12)';
  if (year < currentYear || (year === currentYear && month < currentMonth)) {
    return '有効期限が過去の日付です';
  }
  return null;
};

/**
 * CVVのバリデーション
 * @param {string} cvv - セキュリティコード
 * @returns {string|null} エラーメッセージまたはnull
 */
export const validateCvv = (cvv) => {
  if (!cvv) return 'セキュリティコードを入力してください';
  if (cvv.length < 3) return 'セキュリティコードは3桁以上で入力してください';
  return null;
};

/**
 * カード名義人名のバリデーション
 * @param {string} cardholderName - カード名義人名
 * @returns {string|null} エラーメッセージまたはnull
 */
export const validateCardholderName = (cardholderName) => {
  if (!cardholderName.trim()) return 'カード名義人名を入力してください';
  if (cardholderName.trim().length < 2) {
    return 'カード名義人名は2文字以上で入力してください';
  }
  return null;
};

/**
 * 請求先郵便番号のバリデーション
 * @param {string} billingZipCode - 請求先郵便番号
 * @returns {string|null} エラーメッセージまたはnull
 */
export const validateBillingZipCode = (billingZipCode) => {
  if (!billingZipCode) return '請求先郵便番号を入力してください';
  if (!/^\d{3}-?\d{4}$/.test(billingZipCode)) {
    return '郵便番号は7桁(例:123-4567)で入力してください';
  }
  return null;
};

/**
 * 市区町村のバリデーション
 * @param {string} billingCity - 市区町村
 * @returns {string|null} エラーメッセージまたはnull
 */
export const validateBillingCity = (billingCity) => {
  if (!billingCity.trim()) return '市区町村を入力してください';
  return null;
};

/**
 * 住所のバリデーション
 * @param {string} billingAddress - 住所
 * @returns {string|null} エラーメッセージまたはnull
 */
export const validateBillingAddress = (billingAddress) => {
  if (!billingAddress.trim()) return '住所を入力してください';
  return null;
};

/**
 * 都道府県のバリデーション
 * @param {string} billingState - 都道府県コード
 * @returns {string|null} エラーメッセージまたはnull
 */
export const validateBillingState = (billingState) => {
  if (!billingState) return '都道府県を選択してください';
  return null;
};

/**
 * メールアドレスのバリデーション
 * @param {string} email - メールアドレス
 * @returns {string|null} エラーメッセージまたはnull
 */
export const validateEmail = (email) => {
  if (!email) return 'メールアドレスを入力してください';
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) return '有効なメールアドレスを入力してください';
  return null;
};

/**
 * 電話番号のバリデーション
 * @param {string} phone - 電話番号
 * @returns {string|null} エラーメッセージまたはnull
 */
export const validatePhoneNumber = (phone) => {
  if (!phone) return '電話番号を入力してください';
  const cleanPhone = phone.replace(/-/g, '');
  if (cleanPhone.length < 10 || cleanPhone.length > 11) {
    return '電話番号は10桁または11桁で入力してください';
  }
  return null;
};